import { useContext } from 'react';
import { useStore } from 'zustand';

import type {
  WebKitCustomizationType} from '../providers/WebKitCustomizationProvider';
import {
  WebKitCustomizationContext
} from '../providers/WebKitCustomizationProvider';

export const useWebKitCustomization = <T>(selector: (state: WebKitCustomizationType) => T): T => {
  const store = useContext(WebKitCustomizationContext);
  if (!store) {
    throw new Error('Missing WebKit Customization Provider');
  }

  return useStore(store, selector);
};
